import type { Scalars } from '../__generated-gql-types__/globalTypes';

import { getUrlString } from './url';

export const getClassUrl = (
  classSlug: Scalars['ClassUrn']['output'],
  isFreeEvent?: boolean,
) => {
  return isFreeEvent ? `/event/${classSlug}` : `/class/${classSlug}`;
};

export const getClassUrlObject = (
  classSlug: Scalars['ClassUrn']['output'],
  sessionIdToOpen?: Scalars['CoachingSessionUrn']['output'],
) =>
  getUrlString(
    getClassUrl(classSlug),
    sessionIdToOpen ? { openSid: sessionIdToOpen } : {},
  );
